<app-shared-dialog
  [title]="dialogTitle"
  [options]="dialogOptions"
  (cancel)="close()">
  <div class="team-form-dialog__body">
    <ui-form-field
      [formControl]="teamNameControl"
      [placeholder]="'settings.team_name' | translate"
      [errorMessages]="{ required: 'validation.required' | translate }">
    </ui-form-field>

    <ui-form-field
      type="textarea"
      [formControl]="teamDescriptionControl"
      [placeholder]="'settings.team_description' | translate">
    </ui-form-field>

    <div class="team-form-dialog__members">
      <span class="team-form-dialog__label">{{ 'settings.members' | translate }}</span>

      <div class="team-form-dialog__chips" *ngIf="selectedMembers.length">
        <span class="team-form-dialog__chip" *ngFor="let member of selectedMembers; trackBy: trackByUserId">
          <span class="team-form-dialog__chip-avatar" [style.background]="getUserColor(member)">
            {{ getUserInitials(member) }}
          </span>
          <span class="team-form-dialog__chip-name">{{ member.name }}</span>
          <button
            type="button"
            class="team-form-dialog__chip-remove"
            [attr.aria-label]="'common.remove' | translate"
            (click)="removeMember(member)">&times;</button>
        </span>
      </div>

      <div class="team-form-dialog__search">
        <input
          type="text"
          class="team-form-dialog__search-input"
          [value]="searchTerm"
          (input)="onSearch($any($event.target).value)"
          [placeholder]="'settings.search_name_email' | translate"
          autocomplete="off" />
        <mat-spinner *ngIf="loadingOptions" diameter="16"></mat-spinner>
      </div>

      <ul class="team-form-dialog__results">
        <li *ngFor="let user of searchResults; trackBy: trackByUserId">
          <button
            type="button"
            class="team-form-dialog__result"
            [class.team-form-dialog__result--selected]="isSelected(user)"
            (click)="toggleMember(user)">
            <span class="team-form-dialog__result-avatar" [style.background]="getUserColor(user)">
              {{ getUserInitials(user) }}
            </span>
            <span class="team-form-dialog__result-text">
              <span class="team-form-dialog__result-name">{{ user.name }}</span>
              <span class="team-form-dialog__result-email" *ngIf="user.email">{{ user.email }}</span>
            </span>
            <span class="team-form-dialog__result-check" *ngIf="isSelected(user)">&#10003;</span>
          </button>
        </li>
        <li class="team-form-dialog__results-empty" *ngIf="!loadingOptions && !searchResults.length">
          {{ 'common.no_results' | translate }}
        </li>
      </ul>
    </div>
  </div>

  <div customConfirm>
    <ui-button
      type="primary"
      [label]="saveLabel | uppercase"
      [icon]="isEditMode ? 'pen-cc' : 'plus-cc'"
      iconPosition="start"
      [isLoading]="isSubmitting"
      [disabled]="isFormInvalid || isSubmitting"
      (click)="submitForm()">
    </ui-button>
  </div>
</app-shared-dialog>
